(function () {
  'use strict';

  var REVIEWS_ID = 'judgeme_product_reviews';
  var REVIEWS_HASH = '#' + REVIEWS_ID;
  var OPEN_FORM_FLAG = 'clickableReviews:openForm';
  var READY_TIMEOUT = 6000;

  function findReviewsContainer() {
    return document.getElementById(REVIEWS_ID);
  }

  // Judge.me server-renders `.jdgm-ssr-reviews` immediately; the header and
  // "write a review" trigger are added afterwards once its widget JS hydrates.
  function isWidgetPopulated(el) {
    return !!(el && el.children.length > 0);
  }

  function waitForReviewsWidget(callback) {
    var existing = findReviewsContainer();
    if (existing && isWidgetPopulated(existing)) {
      callback(existing);
      return;
    }

    var settled = false;
    var timeoutId;

    var observer = new MutationObserver(function () {
      var el = findReviewsContainer();
      if (el && isWidgetPopulated(el)) {
        settle(el);
      }
    });

    function settle(el) {
      if (settled) return;
      settled = true;
      observer.disconnect();
      clearTimeout(timeoutId);
      callback(el);
    }

    observer.observe(document.body, { childList: true, subtree: true });

    timeoutId = setTimeout(function () {
      settle(findReviewsContainer());
    }, READY_TIMEOUT);
  }

  function findWriteReviewTrigger(container) {
    var patterns = [/scrie\s*o\s*recenzie/i, /write\s*a\s*review/i, /leave\s*a\s*review/i];
    var candidates = container.querySelectorAll('a, button');

    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').trim();
      for (var j = 0; j < patterns.length; j++) {
        if (patterns[j].test(text)) {
          return candidates[i];
        }
      }
    }

    // Fall back to known Judge.me class names in case the widget markup changes.
    return container.querySelector('.jdgm-write-rev-link, .jdgm-write-review-btn, [data-write-review]');
  }

  function openWriteReviewForm(container) {
    try {
      var trigger = findWriteReviewTrigger(container);
      if (trigger) {
        // Small delay so the click lands after the smooth-scroll settles.
        setTimeout(function () {
          trigger.click();
        }, 400);
      }
    } catch (e) {
      // Judge.me's widget internals aren't a documented public API —
      // fail silently rather than break the page if markup changes.
    }
  }

  function scrollToReviews(openForm) {
    waitForReviewsWidget(function (el) {
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (openForm) {
        openWriteReviewForm(el);
      }
    });
  }

  function consumeOpenFormFlag() {
    var openForm = false;
    try {
      openForm = sessionStorage.getItem(OPEN_FORM_FLAG) === '1';
      sessionStorage.removeItem(OPEN_FORM_FLAG);
    } catch (e) {
      // Storage may be unavailable (private mode, blocked cookies, etc).
    }
    return openForm;
  }

  function isSamePage(link) {
    return link.pathname === window.location.pathname && link.hostname === window.location.hostname;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="' + REVIEWS_HASH + '"]');
    if (!link) return;

    try {
      sessionStorage.setItem(OPEN_FORM_FLAG, '1');
    } catch (e) {
      // Ignore — worst case the review form just won't auto-open.
    }

    if (isSamePage(link)) {
      // Already on this product's page: smooth-scroll instead of a full reload.
      event.preventDefault();
      if (window.location.hash !== REVIEWS_HASH) {
        history.pushState(null, '', REVIEWS_HASH);
      }
      scrollToReviews(consumeOpenFormFlag());
    }
    // Different page: let the browser navigate normally. The destination
    // product page picks up the hash and the flag once it loads (below).
  });

  function handleInitialHash() {
    if (window.location.hash !== REVIEWS_HASH) return;
    scrollToReviews(consumeOpenFormFlag());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialHash);
  } else {
    handleInitialHash();
  }
})();
